export const NOA_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_eco-motion-home/artifacts/rwhos5w9_Noalogo.png";

/**
 * BrandMark — displays the Noa logo (cropped to the round icon portion) + wordmark.
 * The source PNG is a square canvas: round icon (top ~55%) with "NOA" text below on white.
 * We zoom in and shift up so only the round icon shows inside our circular plaque.
 *
 * variant: "light" (default, dark wordmark) | "dark" (light wordmark)
 * size:    "sm" (h-9) | "md" (h-11) | "lg" (h-14)
 */
export default function BrandMark({ variant = "light", size = "sm", showWordmark = true, className = "" }) {
  const heights = { sm: "h-9 w-9", md: "h-11 w-11", lg: "h-14 w-14" };
  const texts = { sm: "text-2xl", md: "text-3xl", lg: "text-4xl" };
  const wordColor = variant === "dark" ? "text-bone" : "text-forest";

  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <span
        className={`${heights[size]} relative rounded-full overflow-hidden shrink-0`}
        style={{ background: "#fff" }}
        aria-hidden="true"
      >
        <img
          src={NOA_LOGO_URL}
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
          style={{ objectPosition: "center 22%", transform: "scale(1.9)" }}
        />
      </span>
      {showWordmark && (
        <span className={`font-serif ${texts[size]} ${wordColor} tracking-tight leading-none`}>Noa</span>
      )}
    </span>
  );
}
